module.exports = __webpack_public_path__ + "img/doxocial-06-loop.bbb4c4f8.gif";